import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { SharedStorageService } from './shared/services/shared-storage.service';

export const authguardGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const sharedStorageService = inject(SharedStorageService);
  const currentPath = state.url;
  const reserveType = sharedStorageService.get('reserveType');

  // 檢查是否為會員中心路徑
  if (currentPath.startsWith('/healthcheck/member')) {
    // 檢查是否已登入
    const loginStatus = sharedStorageService.get('loginStatus');
    if (loginStatus !== 'memberLogin') {
      router.navigate(['/healthcheck/login']);
      return false;
    }
    
    // 檢查是否為頁面刷新（允許）或直接網址訪問（阻止）
    const navigationEntries = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
    const isPageRefresh = navigationEntries.length > 0 && navigationEntries[0].type === 'reload';
    const navigation = router.getCurrentNavigation();
    const isDirectUrl = !navigation || 
      (navigation.trigger === 'imperative' && !navigation.previousNavigation);
    
    if (isDirectUrl && !isPageRefresh) {
      router.navigate(['/healthcheck']);
      return false;
    }
    
    return true;
  }
  
  if (reserveType) {
    // 檢查是否為頁面刷新 或 直接網址訪問
    const navigationEntries = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
    const isPageRefresh = navigationEntries.length > 0 && navigationEntries[0].type === 'reload';
    const navigation = router.getCurrentNavigation();
    const isDirectUrl = !navigation || 
      (navigation.trigger === 'imperative' && !navigation.previousNavigation);
    
    if (isDirectUrl && !isPageRefresh) {
      router.navigate(['/healthcheck']);
      return false;
    }
    
    // 檢查預約流程步驟順序
    const currentStep = sharedStorageService.get('reserveStep') || 1;
    
    // 定義步驟與路徑的對應關係
    const stepPathMap: { [key: number]: string[] } = {
      1: ['/healthcheck/reserve/location'],
      2: ['/healthcheck/reserve/personalinfo','/healthcheck/reserve/personalhistory', '/healthcheck/reserve/familyhistory', '/healthcheck/reserve/symptoms'],
      2.5: ['/healthcheck/reserve/loading'],
      3: ['/healthcheck/reserve/personalplan', '/healthcheck/reserve/companyplan', '/healthcheck/reserve/plancompare'],
      4: ['/healthcheck/reserve/additem'],
      5: ['/healthcheck/reserve/overview', '/healthcheck/reserve/evaluation', '/healthcheck/reserve/reminder'],
      6: ['/healthcheck/reserve/bookinfo'],
      7: ['/healthcheck/reserve/timeselect'],
      8: ['/healthcheck/reserve/review'],
      9: ['/healthcheck/reserve/complete']
    };
    
    // 檢查當前路徑是否符合當前步驟
    const allowedPaths = stepPathMap[currentStep] || [];
    const isValidStep = allowedPaths.some(path => currentPath.startsWith(path));
    
    if (!isValidStep) {
      router.navigate(['/healthcheck']);
      return false;
    }
    
    return true;
  } else {
    // 沒有預約類型，表示是直接輸入網址，導回首頁
    router.navigate(['/healthcheck']);
    return false;
  }
};
